"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_simp_Log = void 0;
const styled_string_1 = __importDefault(require("@jimbui/styled-string"));
const defaultThemes = {
    main: ["underscore", "bright", "fg_gray"],
    controllers: ["underscore", "bright", "fg_b_green"],
    subControllers: ["bright", "fg_b_green"],
    utils: ["underscore", "bright", "fg_b_blue"],
    libs: ["underscore", "bright", "fg_b_blue"],
    cronjobs: ["underscore", "bright", "fg_b_yellow"],
    debug: ["fg_red"],
};
styled_string_1.default.setThemes(Object.assign({}, defaultThemes));
const SHu_simp_Log = (src, theme, config) => {
    const { debug, mute } = config || {};
    const toString = (any) => (typeof any !== "string" ? JSON.stringify(any, null, 4) : any);
    const fLog = (body) => (mute ? {} : console.log(styled_string_1.default.styleString(`[${theme}:${src}:] ${toString(body)}`)));
    const dLog = (body) => (mute || !debug ? {} : console.log(styled_string_1.default.styleString(`[debug:${src}:] ${toString(body)}`)));
    return { fLog, dLog };
};
exports.SHu_simp_Log = SHu_simp_Log;
